import { inject, Injectable, Signal, signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService } from '@softline/core';
import { StatisticTypesRepository } from '../repositories/statistic-types.repository';
import { StatisticType } from '../types/statistic-type';

@Injectable()
export class StatisticTypesService extends ReadonlyRepositoryCollectionService<
  StatisticType,
  StatisticType[],
  undefined
> {
  override readonly params: Signal<undefined> = signal(undefined);

  constructor() {
    super(inject(StatisticTypesRepository));
  }

  protected override getAll(result: StatisticType[] | null | undefined): StatisticType[] {
    return result ?? [];
  }
}
